import * as React from 'react'

import { Box, type ColorUnion, Tag } from '@factorialco/deprecated-design-system'

interface Props {
  label: string
  type: ColorUnion
  colorLine: string
  solid?: boolean
}

const TagSeparator = ({ label, type, colorLine, solid = false }: Props) => {
  return (
    <>
      <Box
        paddingTop="s12"
        paddingBottom="s24"
        alignItems="center"
        justifyContent="center"
        width="full"
        position="relative"
      >
        <hr
          style={{
            borderStyle: 'none',
            borderTop: `2px dotted ${colorLine}`,
            width: '100%',
          }}
        />
        <Box position="absolute">
          <Tag type={type} inline solid={solid}>
            {label}
          </Tag>
        </Box>
      </Box>
    </>
  )
}

export default TagSeparator
